import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { exchangeGoogleSession } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            toast.error("Missing Google session. Please try again.");
            navigate("/login", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(match[1]);
        // Honour ?next= set by the login/register redirect so Google-OAuth
        // users land back where they came from.
        const nextParam = new URLSearchParams(location.search).get("next");
        const redirect = nextParam || "/account";
        (async () => {
            try {
                await exchangeGoogleSession(session_id);
                // Clear the hash from the URL
                window.history.replaceState({}, document.title, window.location.pathname);
                toast.success("Signed in with Google");
                navigate(redirect, { replace: true });
            } catch (err) {
                toast.error(err.response?.data?.detail || "Sign-in failed. Please try again.");
                navigate("/login", { replace: true });
            }
        })();
    }, [exchangeGoogleSession, navigate, location.hash, location.search]);

    return (
        <div className="pt-28 pb-20 min-h-screen flex items-center justify-center" data-testid="auth-callback-page">
            <div className="text-center">
                <div className="inline-block w-10 h-10 border-2 border-[var(--gold)] border-t-transparent rounded-full animate-spin" />
                <p className="mt-4 text-[var(--text-secondary)] font-mono text-xs uppercase tracking-widest">
                    Completing sign-in…
                </p>
            </div>
        </div>
    );
};
